import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CommonService} from "../../../../../shared/services/common.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import * as Validations from "../../../../../shared/constants/validation.constants"
import {GenerateOtpRequest} from "../../../../core/authentication.actions";
import {PhoneNumberFormatPipe} from "../../../../../shared/pipes/phone-number-format.pipe";
import {Subject, takeUntil} from "rxjs";
import {generateOtpInfo, phoneNumber} from "../../../../core/authentication.selectors";


@Component({
  selector: 'app-step-two-right-panel',
  templateUrl: './step-two-right-panel.component.html',
  styleUrls: ['./step-two-right-panel.component.css']
})
export class StepTwoRightPanelComponent {
  private readonly onDestroy: Subject<any> = new Subject<any>();
  validations: any = Validations
  errorMessages: any = {};
  errorMessageMap = {
    phoneNumber: {
      required: 'This field is required.',
      minlength: 'Invalid Phone Number'
    }
  }
  phoneNumber: string = null;
  generateOtpLoading: boolean = false;

  form = new FormGroup({
    phoneNumber: new FormControl({value: '', disabled: false}, {
      validators: [
        Validators.required,
        Validators.minLength(this.validations['phoneNumber'].length.min)
      ]
    }),
  })

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private cdRef: ChangeDetectorRef,
    private phoneNumberFormatPipe: PhoneNumberFormatPipe
  ) {
  }

  ngOnInit() {
    this.store
      .select(phoneNumber)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data?.phoneNumber) {
          this.form.patchValue({
            phoneNumber: this.phoneNumberFormatPipe.transform(data.phoneNumber)
          });
        }
      });

    this.store
      .select(generateOtpInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.generateOtpLoading = data.loading
      })
  }

  getOtp() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrorsInPhoneNumberForm();
      return;
    }
    // EXTRACT VALUE FROM FORM//
    const phoneNumber = this.phoneNumberFormatPipe.cleanPhoneNumber(this.form.getRawValue().phoneNumber);
    // PAYLOAD CREATION//
    const payload = {
      phoneNumber
    };
    // ACTION DISPATCH to get OTP
    this.store.dispatch(GenerateOtpRequest({payload}));
  }

  checkForErrorsInPhoneNumberForm(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  ngAfterViewInit() {
    $($('input')[0]).focus();
    this.cdRef.detectChanges();
  }


  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();

  }

}
